var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.selectedRegion)?_c('img',{attrs:{"src":_vm.selectedRegion.icon,"alt":_vm.selectedRegion.isoCountry}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }